import { getBridgeSDK, isInApp } from "./bridge_sdk"

const BridgeSDK = getBridgeSDK();

export interface PatientInApp {
	accountId: number,
	lastName: string,
	firstName: string,
	midName: string,
	dob: string,
	gender: string,
	address: string,
	city: string,
	state: string,
	zip: string,
	ssn: string,
	race: string,
	ethnicity: string,
	maritalStatus: string,
	homePhone: string,
	phone: string,
	email: string,
	language: string,
	notification: string,
	weight: number,
	height: number,
}

export interface BridgePassProps {
	patient?: PatientInApp | undefined
}

export const openInApp = isInApp;

export default class BridgeHelper {
	static logInfo(message?: any, ...optionalParams: any[]) {
		BridgeSDK.logInfo(message, ...optionalParams)
	}

	static popPage(withProps?: object) {
		BridgeSDK.popPage(withProps)
	}

	static showSpinner(key?: string) {
		BridgeSDK.showSpinner(key)
	}

	static hideSpinner(key?: string) {
		BridgeSDK.hideSpinner(key)
	}
}
